
import { CHAT_MSG_TYPE } from './define'
import { utils } from './utils/utils'
import WebGlLoader from './WebGlLoader'
class WebGlSDK {

    constructor() {
        this.isDev=false
        this.webGlLoader = undefined
    }
    initSDK(documentContainer,backColor,secretConfig,isDev) {
        // let naviInfo = utils.getNavicatObj()
        // if(naviInfo && naviInfo.os && naviInfo.os.name.toLowerCase()=='ios'
        //  && naviInfo.os.version && naviInfo.os.version.original=='16.4'){
        //     alert(`抱歉，您当前的系统 ${naviInfo.os.name}:${naviInfo.os.version.original} 存在兼容性问题`)
        // }
        this.isDev = isDev
        this.webGlLoader = new WebGlLoader(documentContainer,backColor, secretConfig,isDev)
        return [null]
    }
    resetAppID(appId){
        if (!this.webGlLoader) {
            return
         }
         this.webGlLoader.resetAppID(appId)
    }
    enableControl(enable){
        if (!this.webGlLoader) {
           return
        }
        this.webGlLoader.enableControl(enable)
    }
    loadHuman(url, defaultClothName,hdrUrl,changeCloth,actions,defaultAction,config, processCallback, resultCallback) {
        if (!this.webGlLoader) {
            if (resultCallback) resultCallback("sdk还未初始化")
            return
        }
        return this.webGlLoader.loadMainModel(url, defaultClothName,hdrUrl, changeCloth,actions,defaultAction,config,processCallback, resultCallback)
    }
    
    /**
     * 加载音素文件（OVR格式） 并且驱动口型播放音频
     * @param {*} visemeUrl 
     * @param {*} audioUrl 
     * @param {*} eventHandler 'error','start','ended'
     */
    // loadVisemeAndPlay(visemeUrl, audioUrl, eventHandler) {
    //     if (!this.webGlLoader) {
    //         if (eventHandler) eventHandler("error",'加载音素文件失败')
    //         return
    //     }
    //     this.webGlLoader.loadVisemeAndPlay(visemeUrl,audioUrl,eventHandler)
    // }

    /**
     * 虚拟人坐标复位
     */
    resetHumanPosition(){
        if (!this.webGlLoader) {
            return ['sdk未初始化']
        }
        this.webGlLoader.resetHumanPosition()
        return [null,'重置成功']
    }
    /**
     * 加载服装并换装（自动将默认或者上一件服装删除）
     * @param {*} clothes 
     * @param {*} processCallback 
     * @param {*} resultCallback 
     */
    loadAndCLoth(clothes,processCallback,resultCallback){
        if (!this.webGlLoader) {
            if (resultCallback) resultCallback("sdk还未初始化",'服装文件失败')
            return
        }
        this.webGlLoader.loadAndCloth(clothes,processCallback,resultCallback)
    }

    /** @deprecated */ //方法已经启用，请在sdk外部调用聊天接口 
    chat2MetaHumanWord(message,resultCallback,eventHandler){
        if (!this.webGlLoader) {
            if (resultCallback) resultCallback("sdk还未初始化",'聊天失败')
            return
        }
        this.webGlLoader.chat2MetaHuman(message,CHAT_MSG_TYPE.WORD, resultCallback,eventHandler)
    }
    /** @deprecated */ //方法已经启用，请在sdk外部调用聊天接口 
    chat2MetaHumanVoice(voiceBase64Stream,resultCallback,eventHandler){
        if (!this.webGlLoader) {
            if (resultCallback) resultCallback("sdk还未初始化",'聊天失败')
            return
        }
        this.webGlLoader.chat2MetaHuman(voiceBase64Stream,CHAT_MSG_TYPE.VOICE_STREAM, resultCallback,eventHandler)
    }
    stopNowVoice(){
        if (!this.webGlLoader) {
            console.error('sdk还未初始化')
            return
        }
        this.webGlLoader.stopNowVoice()
    }
    clearCache(){
        if (!this.webGlLoader) {
            return
        }
        this.webGlLoader.clearThreeCatch()
    }
    showStats(show){
        if (!this.webGlLoader) {
            return
        }
        this.webGlLoader.showStats(show)
    }
      /**
     * 播报并播放动作
     * @param {*} audio 
     * @param {*} audioVisem 
     * @param {*} resultCallback(err,res)
     * @param {*} eventHandler
     */
    say(audio,audioVisem, duration,conf,resultCallback, eventHandler){
        if (!this.webGlLoader) {
            return
        }
        this.webGlLoader.say(audio,audioVisem,duration,conf, resultCallback, eventHandler)
    }
    setAudioMuted(muted){
        if (!this.webGlLoader) {
            return
        }
        this.webGlLoader.setAudioMuted(muted)
    }
    /**
     * 播放动作
     * @param {*} action 
     * @param {*} fadeDuration 
     * @returns 
     */
    playAction(action,fadeDuration){
        if (!this.webGlLoader) {
            return
        }
        this.webGlLoader.playAction(action,fadeDuration)
    }

    playIdleAction(){
        if (!this.webGlLoader) {
            return
        }
        this.webGlLoader.playIdleAction()
    }

    downloadCanvasImg(callback){
        if (!this.webGlLoader) {
            return
        }
        this.webGlLoader.downloadCanvasImg(callback)
    }

    setJWAOpenValue(value){
        if (!this.webGlLoader) {
            return
        }
        this.webGlLoader.setJWAOpenValue(value)
    }
}
export default new WebGlSDK()


// WEBPACK FOOTER //
// ./src/S51WebGLSDK/index.js